import React from 'react';
import { Select, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguage } from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const { t } = useTranslation();

  return (
    <Select
      value={currentLanguage}
      onChange={changeLanguage}
      size="small"
      suffixIcon={<GlobalOutlined />}
      style={{ minWidth: 120 }}
      popupMatchSelectWidth={false}
    >
      {availableLanguages.map(language => (
        <Option key={language.code} value={language.code}>
          {t(`language.${language.name.toLowerCase()}`, language.nativeName)}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSwitcher;
